import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./Layout";
import Profile from "./Profile";
import { getPermissions } from "../../Utils/auth";
import { getAllowedRoutes } from "../../Utils/getAllowedRoutes";
import Notifications from "../AdminModule/Notifications";

const UserRoute = () => {
  const permissions = getPermissions(); // e.g. ["manage_employees", "manage_leaves"]
  const allowedRoutes = getAllowedRoutes(permissions);
  console.log("hello");
  return (
    <Routes>
      {allowedRoutes.map((route) => (
        <Route
          key={route.key}
          path={route.path}
          element={<Layout>{route.element}</Layout>}
        />
      ))}
      <Route
        exact
        path="/notifications"
        element={
          <Layout>
            <Notifications />
          </Layout>
        }
      />
      <Route
        exact
        path="/profile"
        element={
          <Layout>
            <Profile />
          </Layout>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default UserRoute;
